import { Stack } from "@braintrust/braintrust-ui-components";
import { CoreLayout } from "@js/layouts/core";

import { SignUpConfirmationContent } from "../../components/sign-up-confirmation-content";

import styles from "./styles.module.scss";

export const SignUpEmailConfirmPage = () => {
  return (
    <CoreLayout
      pageTitle="Check your email to verify your account."
      className={styles.wrapper}
    >
      <Stack sx={{ maxWidth: "930px", alignItems: "center", px: "20px" }}>
        <SignUpConfirmationContent />
      </Stack>
    </CoreLayout>
  );
};
